import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

import { CUSTOM_SVG_ICONS } from '../constants/custom-icons.constants';

@Injectable({
  providedIn: 'root',
})
export class CustomIconRegistryService {
  private initialized = false;

  constructor(
    private readonly iconRegistry: MatIconRegistry,
    private readonly sanitizer: DomSanitizer
  ) {}

  initialize(): void {
    if (this.initialized) {
      return;
    }

    Object.entries(CUSTOM_SVG_ICONS).forEach(([name, path]) => {
      this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(path));
    });

    this.initialized = true;
  }
}
